'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const PaymentAffirmAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 84 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "rect",
        {
          x: 0.5,
          y: 0.5,
          width: 83,
          height: 57,
          rx: 3.5,
          fill: "white",
          stroke: "#E1E0DF"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M36.541 31.1789H33.9819V30.1746C33.9819 28.8685 34.7281 28.4947 35.3719 28.4947C36.0821 28.4947 36.6354 28.81 36.6354 28.81L37.5067 26.8188C37.5067 26.8188 36.6235 26.2416 35.0181 26.2416C33.2131 26.2416 31.1595 27.2591 31.1595 30.4526V31.1789H26.8753V30.1746C26.8753 28.8685 27.6215 28.4947 28.2639 28.4947C28.6297 28.4947 29.1218 28.5799 29.5288 28.81L30.4 26.8188C29.8799 26.5129 29.0447 26.2416 27.9114 26.2416C26.1065 26.2416 24.0528 27.2591 24.0528 30.4526V31.1789H22.4142V33.3575H24.0528V41.0547H26.8753V33.3575H31.1595V41.0547H33.9819V33.3575H36.541V31.1789ZM15.9344 39.2828C15.1922 39.2828 14.8224 38.9183 14.8224 38.3158C14.8224 37.2012 16.0701 36.8195 18.3472 36.5787C18.3472 38.0697 17.339 39.2828 15.9344 39.2828ZM16.916 30.8886C15.2893 30.8886 13.4165 31.6561 12.4004 32.4661L13.3288 34.42C14.1441 33.6738 15.4622 33.0367 16.6513 33.0367C17.7806 33.0367 18.4044 33.4144 18.4044 34.1739C18.4044 34.6873 17.9907 34.9454 17.2086 35.0465C14.2904 35.4269 12 36.2316 12 38.4821C12 40.2657 13.2702 41.3457 15.2547 41.3457C16.6699 41.3457 17.9308 40.5583 18.5307 39.5195V41.0545H21.1696V34.6235C21.1696 31.9673 19.3234 30.8886 16.916 30.8886ZM43.4167 31.1788V41.0547H46.2418V36.297C46.2418 34.0345 47.6105 33.3708 48.5655 33.3708C48.9379 33.3708 49.4407 33.4786 49.7732 33.7273L50.288 31.1163C49.8517 30.9301 49.3955 30.8889 49.0217 30.8889C47.5693 30.8889 46.6568 31.5326 46.0543 32.8388V31.1788H43.4167ZM60.192 32.6236C60.7733 31.7723 61.8892 30.8891 63.3829 30.8891C65.1878 30.8891 66.6815 32.0091 66.6815 34.229V41.055H63.8591V35.1215C63.8591 33.814 63.0717 33.2713 62.3255 33.2713C61.3918 33.2713 60.4581 34.1252 60.4581 35.9714V41.055H57.6356V35.1414C57.6356 33.7941 56.8934 33.2713 56.0861 33.2713C55.1936 33.2713 54.2386 34.1452 54.2386 35.9714V41.055H51.4121V31.1791H54.1348V32.6728C54.6123 31.7191 55.6458 30.8891 57.1395 30.8891C58.5081 30.8891 59.652 31.5236 60.192 32.6236ZM41.046 41.0551H38.2262V31.1792H41.046V41.0551Z",
          fill: "#060809"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M54.677 17.4039C47.0529 17.4039 40.2575 22.6963 38.3289 29.5011H41.0928C42.7036 24.4334 48.1715 19.9856 54.677 19.9856C62.5843 19.9856 69.4183 26.0056 69.4183 35.3774C69.4183 37.4816 69.1457 39.3783 68.6296 41.0542H71.311L71.3376 40.9624C71.7766 39.2333 72 37.3552 72 35.3774C72 24.9256 64.384 17.4039 54.677 17.4039Z",
          fill: "#4A4AF4"
        }
      )
    ]
  }
);
const VpPaymentAffirmAsset = forwardRef(PaymentAffirmAsset);

export { VpPaymentAffirmAsset as default };
